import { Backdrop, Card, CircularProgress, Grid, Switch, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";

const BackdropRelative = styled(Backdrop)({
  "&.MuiBackdrop-root": {
    position: "absolute",
    borderRadius: "0.75rem",
  },
});

const CustomMDAvatar = styled(MDAvatar)({
  "& .MuiAvatar-img": {
    height: "100%",
  },
});

export default function StudentCard({
  imgLink,
  name,
  sem,
  branch,
  admissionNo,
  isInOut,
  onInOutToggle,
  isIn,
  isCheckingInOut,
}) {
  const [uicontrol] = useMaterialUIController();
  const textColor = uicontrol.darkMode ? "#ffffff" : "default";
  return (
    <Grid container>
      <Grid lg={4} md={2} xs={0} item />
      <Grid lg={4} md={8} xs={12} item>
        <Card sx={{ textAlign: "center", position: "relative" }} raised>
          <MDBox p={2}>
            <Grid container>
              <Grid lg={4} md={4} item />
              <Grid lg={4} xs={12} md={4} item sx={{ display: "flex", justifyContent: "center" }}>
                <CustomMDAvatar
                  src={imgLink}
                  size="xxl"
                  sx={{ bgcolor: grey[500], margin: "0.5rem" }}
                />
              </Grid>

              <Grid lg={4} md={4} item />
              <Grid lg={12} xs={12} item>
                <Typography color={textColor} variant="h6">
                  {name}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography color={textColor} variant="subtitle2">
                  {sem}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography color={textColor} variant="subtitle2">
                  {branch}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item>
                <Typography color={textColor} variant="subtitle2">
                  {admissionNo}
                </Typography>
              </Grid>
            </Grid>
            {isInOut ? (
              <Typography
                variant="caption"
                color={isIn ? "green" : "red"}
                sx={{ fontWeight: "bold" }}
              >
                {isIn ? "IN" : "OUT"} <Switch checked={isIn} onChange={onInOutToggle} />
              </Typography>
            ) : (
              ""
            )}
          </MDBox>
          <BackdropRelative open={isCheckingInOut}>
            <CircularProgress color="light" />
          </BackdropRelative>
        </Card>
      </Grid>
      <Grid lg={4} xs={4} md={4} item />
    </Grid>
  );
}
